import MuiAccordion from '@mui/material/Accordion'
import MuiAccordionSummary from '@mui/material/AccordionSummary'
import MuiAccordionDetails from '@mui/material/AccordionDetails'
import { styled } from '@mui/material/styles'
import { useEffect, useState } from 'react'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ListView from './list'
import CONSTANT from '../../../Constant/Constant'
import { Add, Remove } from '@mui/icons-material'
import { Link } from 'react-router-dom'

const Accordion = styled(props => (
  <MuiAccordion disableGutters square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {  
    marginBottom: 10
  },
  boxShadow: 'none'
}))

const AccordionSummary = styled(props => (
  <MuiAccordionSummary
    expandIcon={<ExpandMoreIcon sx={{ fontSize: '0.9rem' }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor: '#eeeeee',
  boxShadow: 'none',
  border: 'none',
  borderRadius: 'none',
  '& .MuiAccordionSummary-content': {}
}))

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  border: 'none'
}))

const ConsentAccordian = props => {
  const {
    sources,
    fieldLabelData,
    listLabel,
    subAccordianLabel,
    response
  } = props
  const [accordianExpand, setAccordianExpand] = useState(false)
  const [indexView, setIndexView] = useState(CONSTANT.SHOW_VALUE_NUMBER)
  const [allValue, setAllValue] = useState()
  const [responseValue, setResponseValue] = useState()

  const sortData = (sortedValue, label) => {
    if (sortedValue !== undefined) {
      let allValueSorted = JSON.parse(JSON.stringify(sortedValue))
      let firstTopValues = JSON.parse(JSON.stringify(sortedValue))
      if (sortedValue && label !== 'Relation') {
        firstTopValues = [].concat(sortedValue).sort((a, b) => {
          if (
            a.Rank !== undefined &&
            b.Rank !== undefined &&
            a.Rank.length > 0 &&
            b.Rank.length > 0
          ) {
            return a.Rank[0].value > b.Rank[0].value ? 1 : -1
          } else if (a.Rank !== undefined && b.Rank === undefined) {
            return -1
          } else if (a.Rank === undefined && b.Rank !== undefined) {
            return 1
          } else {
            return 1
          }
        })
        allValueSorted = JSON.parse(JSON.stringify(firstTopValues))
        if (allValueSorted.length > CONSTANT.SHOW_VALUE_NUMBER) {
          firstTopValues = firstTopValues.slice(0, CONSTANT.SHOW_VALUE_NUMBER)
        }
      }
      return { allValueSorted, firstTopValues }
    } else {
      return { allValueSorted: undefined, firstTopValues: undefined }
    }
  }

  useEffect(() => {
    let sortTheValues = sortData(response, subAccordianLabel)
    setResponseValue(sortTheValues.firstTopValues)
    setAllValue(sortTheValues.allValueSorted)
  }, [response, subAccordianLabel])

  /**
   * Show more
   */
  const showMore = () => {
    setIndexView(indexView + CONSTANT.SHOW_VALUE_INCREMENT)
    if (indexView + CONSTANT.SHOW_VALUE_INCREMENT < allValue.length) {
      setResponseValue(
        allValue.slice(0, indexView + CONSTANT.SHOW_VALUE_INCREMENT)
      )
    } else {
      setResponseValue(allValue)
    }
  }

  /**
   * Show Less
   */
  const showLess = () => {
    setIndexView(CONSTANT.SHOW_VALUE_NUMBER)
    setResponseValue(allValue.slice(0, CONSTANT.SHOW_VALUE_NUMBER))
  }

  /**
   * Handle Accordian click
   * @param {*} prev
   */
  const closeAccordian = prev => {
    setAccordianExpand(!prev)
  }

  return (
    <Accordion className='p-0 mt-2' expanded={accordianExpand}>
      <AccordionSummary
        onClick={() => closeAccordian(accordianExpand)}
        expandIcon={<ExpandMoreIcon />}
        aria-controls='panel1-content'
      >
        {subAccordianLabel}
      </AccordionSummary>
      <AccordionDetails className='row p-2'>
        {responseValue?.map((val, i) => {
          return (
            <ListView
              key={i}
              label={`${subAccordianLabel} ${i + 1}`}
              value={val}
              index={i + 1}
              sources={sources}
              fieldLabelData={fieldLabelData}
              accordianLabel={listLabel}
            />
          )
        })}

        {allValue !== undefined &&
          allValue.length > CONSTANT.SHOW_VALUE_NUMBER &&
          allValue.length !== responseValue.length && (
            <Link
              to='#'
              className='d-flex justify-content-center _wg-dynamic-text'
              onClick={showMore}
            >
              {' '}
              ShowMore <Add />{' '}
            </Link>
          )}
        {allValue !== undefined &&
          allValue.length === responseValue.length &&
          responseValue.length > CONSTANT.SHOW_VALUE_NUMBER && (
            <Link
              to='#'
              className='d-flex justify-content-center _wg-dynamic-text'
              onClick={showLess}
            >
              {' '}
              ShowLess
              <Remove />
            </Link>
          )}
      </AccordionDetails>
    </Accordion>
  )
}
export default ConsentAccordian
